import { useEffect } from 'react';

/**
 * Tracks transient overlays — dropdowns, context menus, the linked-record modal
 * (REG-600).
 *
 * The persistent merchant panel also closes on Escape. Without a shared notion
 * of "something lighter is open on top", one Escape dismissed the dropdown and
 * the whole workspace behind it. Document-level keydown listeners fire in
 * registration order, so ordering alone cannot decide this reliably; the panel
 * asks this registry instead.
 */
let openOverlays = 0;

/** True while any transient overlay is on screen. */
export function hasOpenTransientOverlay(): boolean {
  return openOverlays > 0;
}

/**
 * Count a transient overlay as open for as long as `isOpen` holds. Call from
 * the component that renders the overlay.
 */
export function useTransientOverlay(isOpen: boolean): void {
  useEffect(() => {
    if (!isOpen) return;
    openOverlays += 1;
    return () => {
      openOverlays = Math.max(0, openOverlays - 1);
    };
  }, [isOpen]);
}
